import RightSidebarNotifications from './RightSidebarNotifications';

export default RightSidebarNotifications;
